import { FC } from 'react';

import FlightStatusFilter from 'components/FlightStatusFilter';
import FlightUpdateStatusFilter from 'components/FlightUpdateStatusFilter';

type Props = {};

const FlightListToolbar: FC<Props> = props => {
  return (
    <>
      <FlightUpdateStatusFilter sx={{ width: '200px', mr: 1 }} />
      <FlightStatusFilter sx={{ width: '200px', mr: 1 }} />
    </>
  );
};

export default FlightListToolbar;
